import { encodeBase64 } from "./utils/encode";
/// API

export const celuQrPrefix = 'celu#'

/**
 * Modo de acceso a los APIs.
 *
 * PROXY (por defecto en cualquier host que no sea local): las peticiones van a
 * /api/onboarding/* y /api/services/* (mismo origen) y es la Azure Function la
 * que inyecta las api-keys server-side. Las keys NUNCA llegan al navegador.
 *
 * DIRECTO (solo localhost): se llama a los backends directamente usando las
 * keys de dev que están en public/config.js.
 *
 * Se puede forzar cualquiera de los dos definiendo window.MASTER_USE_PROXY
 * (true/false) en public/config.js.
 */
const detectProxyMode = () => {
  if (typeof window === 'undefined') return true
  if (typeof window.MASTER_USE_PROXY === 'boolean') return window.MASTER_USE_PROXY
  const host = window.location.hostname
  // Cierra por defecto: cualquier despliegue real usa el proxy.
  return !(host === 'localhost' || host === '127.0.0.1' || host === '[::1]')
}

export const USE_PROXY = detectProxyMode()

export const CONFIG_SETTINGS = {
  USE_PROXY,
  SERVICES_API_URL: USE_PROXY ? '/api/services' : `${window.MASTER_SERVICES_API_URL}`,
  // En modo proxy quedan vacías a propósito: los secretos los pone la Function.
  API_APIKEY: USE_PROXY ? '' : `${window.MASTER_API_KEY}`,
  API_USERNAME:window.MASTER_API_USERNAME,
  API_PASSWORD:window.MASTER_API_PASSWORD,
  GOOGLE_RECAPTCHA_KEY:window.MASTER_GOOGLE_RECAPTCHA_KEY,
  GOOGLE_MAP_KEY:window.MASTER_GOOGLE_MAP_KEY,
  SUCCESS_TITLE:window.MASTER_SUCCESS_TITLE,
  SUCCESS_MESSAGE:window.MASTER_SUCCESS_MESSAGE,
  CMS_API_URL:window.MASTER_CMS_API_URL,
  CMS_DEVICE_UUID:window.MASTER_CMS_DEVICE_UUID,
  CMS_AES_KEY:window.MASTER_CMS_AES_KEY,
  CMS_AES_IV:window.MASTER_CMS_AES_IV,
  CMS_USERNAME:window.MASTER_CMS_USERNAME,
  CMS_PASSWORD:window.MASTER_CMS_PASSWORD,
  ONBOARDING_URL: USE_PROXY ? '/api/onboarding' : window.MASTER_ONBOARDING_URL,
  // En modo proxy queda vacía a propósito: el secreto lo pone la Function.
  ONBOARDING_APIKEY: USE_PROXY ? '' : window.MASTER_ONBOARDING_APIKEY,
}

//console.log('SETTINGS', CONFIG_SETTINGS)

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
    H_MOBILE: 64,
    H_MAIN_DESKTOP: 88,
    H_DASHBOARD_DESKTOP: 92,
    H_DASHBOARD_DESKTOP_OFFSET: 92 - 32,
  };
  
  export const NAV = {
    W_BASE: 260,
    W_DASHBOARD: 280,
    W_DASHBOARD_MINI: 88,
    //
    H_DASHBOARD_ITEM: 48,
    H_DASHBOARD_ITEM_SUB: 36,
    //
    H_DASHBOARD_ITEM_HORIZONTAL: 32,
  };
  
  export const ICON = {
    NAV_ITEM: 24,
    NAV_ITEM_HORIZONTAL: 22,
    NAV_ITEM_MINI: 22,
  };
  